import { Component, Input, OnInit } from '@angular/core';
import { placeholderTypes } from '../../../constants/placeholder-types.constants';
import { environment } from '../../../../environments/environment';

const imgixHost = environment.imgixHost;
const customCss = `
    .home-slider-placeholder {
      background-image: url('${imgixHost}/website/background-patterns/peach-pattern.jpg?&auto=format');
    }
  `;

@Component({
  selector: 'app-loading-placeholder',
  templateUrl: './loading-placeholder.component.html',
  styleUrls: ['./loading-placeholder.component.scss'],
  styles: [customCss],
  standalone: false
})
export class LoadingPlaceholderComponent implements OnInit {
  placeholderTypes = placeholderTypes;
  @Input() type: string;
  @Input() loopArray: Array<number>;

  constructor() {}

  ngOnInit() {}
}
